import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import store from './store/index'
import { Provider } from 'react-redux';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

(window as any).pdfjsLib = (window as any)['pdfjs-dist/build/pdf'];
(window as any).pdfjsLib.GlobalWorkerOptions.workerSrc = "pdf.worker.js";

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

setTimeout(function () {
  // Google Tag Manager
  (function (w: any, d: any, s: any, l: any, i: any) {
    w[l] = w[l] || []; w[l].push({
      'gtm.start':
        new Date().getTime(), event: 'gtm.js'
    }); var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s), dl = l !== 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
        '//www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-538F83');
}, 1000);

(window as any).Tiff.initialize({
  TOTAL_MEMORY: 100000000
});

if (!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
  document.getElementById('div-browser-compatibility-warn')!.style.display = 'block';
}